import LayoutHome from '@/views/layout/index'

const routes = [{
    path: '/',
    redirect: '/index',
    component: LayoutHome,
    children: [{
      path: 'index',
      component: () => import('@/views/home/home'),
      meta: {}
    }, {
      path: '/login',
      component: () => import('@/views/login/login'),
      meta: {}
    }, {
      path: '/register',
      component: () => import('@/views/login/register'),
      meta: {}
    }, {
      path: '/settled',
      component: () => import('@/views/login/settled'),
      meta: {}
    }, {
      path: '/entrust',
      component: () => import('@/views/home/entrust'),
      meta: {}
    }, {
      path: '/search',
      component: () => import('@/views/home/search'),
      meta: {}
    }]
  },
  {
    path: '/beginner',
    redirect: '/beginner/index',
    component: LayoutHome,
    children: [{
      path: 'index',
      component: () => import('@/views/beginner/index'),
      meta: {}
    }]
  },
]
export default routes
